module.exports = __webpack_public_path__ + "img/4.ccf144e3.jpg";